export class DiscretizeAdapter {
  static toInputDTO(req: any): any {
    const data_properties_list = req.map((e: any) => {
      const extractId = (
        arr: Array<{ id: string; value: boolean }>
      ): string | null => {
        const found = arr.find((item) => item.value);
        return found ? found.id : null;
      };

      return {
        value: e.id,
        layer_no: extractId(e.layer_rule),
        is_auto_range: extractId(e.is_auto_disc) === "auto",
        is_outlier: extractId(e.is_outlier_rej) === "on",
        bins_num: null,
        level_boundary_list: null,
      };
    });
    return { data_properties_list };
  }

  static toOutputDTO(res: any): any[] {
    return (
      res.discretization_list.map((e: any) => {
        return {
          id: e.value,
          name: e.name,
          // data_range: null,
          is_auto_disc: ["auto", "manual"].map((attr) => ({
            id: attr.toString(),
            key: attr.toString(),
            value: e.is_auto_range ? attr === "auto" : attr === "manual",
          })),
          is_outlier_rej: ["on", "off"].map((attr) => ({
            id: attr.toString(),
            key: attr.toString(),
            value: e.is_outlier ? attr === "on" : attr === "off",
          })),
          // is_cont: null,
          // is_ord: null,
          // auto_disc_type: null,
          // feat_scale_type: null,
          // disc: null,
          layer_rule: [1, 2, 3].map((attr) => ({
            id: attr,
            key: attr.toString(),
            value: e.layer_no === attr,
            meta: {
              label: attr,
            },
          })),
          disc_upd_at: e.discretization_fixed_at ?? null,
        };
      }) || []
    );
  }
}
